/**
 * StyleIndicator - Indicador visual del estilo/nivel activo de DamyxIA
 * Muestra un pequeño badge con el estilo y nivel de comunicación actual
 */
import { Smile, Briefcase, GraduationCap, Sparkles, Zap } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const StyleIndicator = ({ profile, styleWasManual, levelWasManual }) => {
  const { language } = useLanguage();
  
  if (!profile) return null;
  
  const txt = {
    es: {
      style: 'Estilo',
      level: 'Nivel',
      informal: 'Casual',
      neutro: 'Neutro',
      formal: 'Profesional',
      basico: 'Básico',
      intermedio: 'Intermedio',
      avanzado: 'Avanzado',
      auto: 'Auto',
      manual: 'Manual',
    },
    en: {
      style: 'Style',
      level: 'Level',
      informal: 'Casual',
      neutro: 'Neutral',
      formal: 'Professional',
      basico: 'Basic',
      intermedio: 'Intermediate',
      avanzado: 'Advanced',
      auto: 'Auto',
      manual: 'Manual',
    }
  };
  const t = txt[language] || txt.es;
  
  const styleConfig = {
    informal: { icon: Smile, color: 'text-green-400', bg: 'bg-green-500/10', label: t.informal },
    neutro: { icon: Zap, color: 'text-amber-400', bg: 'bg-amber-500/10', label: t.neutro },
    formal: { icon: Briefcase, color: 'text-blue-400', bg: 'bg-blue-500/10', label: t.formal },
  };
  
  const levelConfig = {
    basico: { icon: '🌱', color: 'text-emerald-400', label: t.basico },
    intermedio: { icon: '📚', color: 'text-amber-400', label: t.intermedio },
    avanzado: { icon: '🎓', color: 'text-purple-400', label: t.avanzado },
  };
  
  const style = styleConfig[profile.style] || styleConfig.neutro;
  const level = levelConfig[profile.technical_level] || levelConfig.intermedio;
  const StyleIcon = style.icon;
  
  return (
    <div className="flex items-center gap-2 text-xs" data-testid="style-indicator">
      {/* Style badge */}
      <div 
        className={`flex items-center gap-1 px-2 py-0.5 rounded-full ${style.bg} ${style.color} border border-current/20`}
        title={`${t.style}: ${style.label} ${styleWasManual ? `(${t.manual})` : `(${t.auto})`}`}
      >
        <StyleIcon className="w-3 h-3" />
        <span className="font-medium">{style.label}</span>
        {styleWasManual && <Sparkles className="w-2.5 h-2.5 opacity-70" />}
      </div>
      
      {/* Level badge */}
      <div 
        className={`flex items-center gap-1 px-2 py-0.5 rounded-full bg-zinc-800/50 ${level.color} border border-current/20`}
        title={`${t.level}: ${level.label} ${levelWasManual ? `(${t.manual})` : `(${t.auto})`}`}
      >
        <span>{level.icon}</span>
        <span className="font-medium">{level.label}</span>
        {levelWasManual && <Sparkles className="w-2.5 h-2.5 opacity-70" />}
      </div>
    </div>
  );
};

export default StyleIndicator;
